import React from 'react'
import SubHeader from '../../../layout/components/SubHeader'
import {toAbsoluteUrl} from '../../../helpers/AssetHelpers'
import UserCard from "./UserCard";

function UserSettings() {
    return (
        <>
            <SubHeader title="User Settings" description={"Manage your clinic's users settings."}/>
            <div className="row mt-3">
                <div className="col-3">
                    <img src={toAbsoluteUrl('/media/illustrations/ecx/avatars_xsfb.svg')} className='img-fluid p-5' />
                </div>
                <div className="col-9">
                    <UserCard />
                </div>
            </div>
        </>
    )
}

export default UserSettings